import React from 'react';
import OidcCallback from '../components/auth/OidcCallback';

export default function OidcCallbackPage() {
  return <OidcCallback />;
}
